import PropTypes from 'prop-types';
import { attr, Model } from 'redux-orm';

class DashboardV2Readiness extends Model {
  static modelName = 'DashboardV2Readiness';

  static fields = {
    id: attr(),
    patientId: attr(),
    patient: attr(),
    workflowInstanceId: attr(),
    overall: attr(),
    coreReadiness: attr(),
    edgeReadiness: attr(),
    dimensions: attr(),
    computedAt: attr(),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      patientId: PropTypes.number,
      patient: PropTypes.object,
      workflowInstanceId: PropTypes.string,
      overall: PropTypes.object,
      coreReadiness: PropTypes.object,
      edgeReadiness: PropTypes.object,
      dimensions: PropTypes.object,
      computedAt: PropTypes.string,
    }),
  };
}

export default DashboardV2Readiness;
